import { Component, OnInit , Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth.service';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProjectService } from 'src/app/project/project.service';
import { LoginResponseNew } from 'src/app/polar-SAAS-Components/models-new';
@Component({
  selector: 'app-callback',
  template: `<div>Processing Azure Login...</div>`,
  styles: []
})
export class CallbackComponent implements OnInit {
 @Output() tokenExchangeSuccess = new EventEmitter<any>();
  loginError: string;
  loginResponse: LoginResponseNew;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private projectService: ProjectService
  ) {}

  ngOnInit() {
      this.route.queryParams.subscribe((params) => {
      const code = params['code'];
      const state = params['state'];
      const marketplaceToken = state && state.split('|')[1];

      if (code) {
        console.log("Authorization code received.");
        console.log("marketplace token: {}", marketplaceToken)

        this.exchangeAuthorizationCode(code, marketplaceToken);
      } else {
        console.error("No authorization code received.");
        this.router.navigate(['/login']);
      }
    });

}
private exchangeAuthorizationCode(code: string, marketplaceToken?: string) {
    const payload = {
      code,
      client_id: environment.client_id,
      client_secret: environment.client_secret,
      marketplaceToken,
    };
    this.spinner.show();
    this.http.post(environment.host + '/open/azure-login', { payload }).subscribe({
      next: (response: any) => {
        this.loginResponse = response.content;
        AuthService.loadCredential(this.loginResponse);
        this.projectService.corporateSource.next(null);
      
     if (this.loginResponse.role==101 ){
        localStorage.setItem("CORPORATE_ID",this.loginResponse.references[0])
        localStorage.setItem("USERNAME",this.loginResponse.name);
        localStorage.setItem("PLAN_ID",this.loginResponse.planId);
        this.spinner.hide();
        if(this.loginResponse.isSignup==true){
        this.router.navigate(['azure-login']);
        }
        else{
        this.router.navigate(['']);
        }
       }
        else if ( this.loginResponse.role < 10000) {
          const reqUrl = localStorage.getItem('REQUESTED_URL');
          this.router.navigate([reqUrl ? reqUrl : '']);
          localStorage.setItem('REQUESTED_URL', '');
          this.spinner.hide();
        } else if ( this.loginResponse.role === 10000) {
          this.router.navigate(['/device', 'D_U']);
          this.spinner.hide();
        }
      },
      error: (error) => {
        sessionStorage.setItem('loginError', error.error.message);
         
        // Redirect to login on error
        this.router.navigate(['/login']);
        this.spinner.hide();
      },
    });
  }  
}
